import { render, staticRenderFns } from "./BaseAddButton.vue?vue&type=template&id=ac53c922&scoped=true&"
import script from "./BaseAddButton.vue?vue&type=script&lang=ts&"
export * from "./BaseAddButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAddButton.vue?vue&type=style&index=0&id=ac53c922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac53c922",
  null
  
)

export default component.exports